<template>
  <!-- {{ paymentID }} -->
  <div class="d-flex justify-content-center align-items-center error-container">
    <div class="text-center">
      <div class="faipay-fs">Processing request please wait ..!</div>

      <!-- <div class="text-center mt-4">
         <router-link to="" class="retry-btn">RETRY</router-link>
      </div> -->
    </div>
  </div>
</template>
<script>
import Slick from "vue-slick";
import { makeRequest, makeRequestDirect } from "@/helper/internet.js";
import { mapState, mapGetters, mapActions } from "vuex";
import { EVENT_URL, URL_BASE } from "@/helper/constant.js";
import moment from "moment";

export default {
  data() {
    return {
      paymentID: 0,
      BASEURL: URL_BASE,
      successURL: window.location.origin + "/confirmBooking",
      failedURL: window.location.origin + "/failedPayment",
      url: EVENT_URL,
    };
  },
  beforeMount() {
    // this.showLoading();
    const { paymentID } = this.$route.params;
    this.paymentID = paymentID;
    this.checkPayment();
    // window.location.href =
    //   `${this.BASEURL}/FinalBooking?PaymentGatewayID=` +
    //   this.paymentID +
    //   `&ApiCallURL=${this.BASEURL}` +
    //   `&SucessUrl=${this.successURL}` +
    //   `&FailUrl=${this.failedURL}`;
  },
  mounted() {},
  methods: {
    checkPayment() {
      let url1 =
        this.paymentID === "undefined"
          ? `/v1/payment/reserve-check-payment/${this.$cookies.get(
              "reseverID"
            )}`
          : `/v1/payment/check-payment/${this.paymentID}`;
      console.log("url", this.url + url1);
      makeRequest(url1, "GET", null, null, this.url)
        .then((response) => {
          const { error, res } = response;
          if (!error && res.data) {
            if (!error) {
              console.log(res.data);
              if (res.data.pg_response) {
                if (res.data.pg_status == "success") {
                  if (res.data.book_type == "movie") {
                    this.$router.push("/confirmBooking/" + res.data.booking_id);
                  } else {
                    this.$router.push(
                      "/payment-completed/" + res.data.booking_id
                    );
                  }
                } else if (res.data.pg_status == "cancel") {
                  this.$router.push("/payment-cancelled/" + res.data.order_id);
                } else {
                  // payment-cancelled/1474
                  this.$router.push("/payment-failed/" + res.data.order_id);
                }
              } else {
                let that = this;
                setTimeout(function () {
                  that.checkPayment();
                }, 2000);
              }
              // if (
              //   res.data.Status == false &&
              //   res.data.BookStatus == "pending"
              // ) {
              //   let that = this;
              //   setTimeout(function () {
              //     that.checkPayment();
              //   }, 2000);
              // } else if (
              //   res.data.Status == true &&
              //   res.data.BookStatus == "booked"
              // ) {
              //   this.$router.push("/confirmBooking/" + res.data.Message);
              // } else {
              //   this.$router.push("/failedPayment");
              // }
            }
          } else {
            console.log("Response Error ");
          }
        })
        .catch((error) => {
          console.log("Error", error);
        });
    },
  },
};
</script>

<style>
.sbcls {
  width: 100px;
  height: 100px;
  margin-top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/processPayment1.vue